import { Routes, Route } from 'react-router-dom';
import { IconSprite } from './assets/icons/IconSprite';
import MainLayout from './components/layout/MainLayout';
import ProtectedRoute from './components/auth/ProtectedRoute';
import LoginPage from './views/auth/LoginPage';
import RegisterPage from './views/auth/RegisterPage';
import AuthCallback from './views/auth/AuthCallback';

// Core Views
import Dashboard from './views/dashboard/Dashboard';
import Tenants from './views/tenants/Tenants';
import Users from './views/users/Users';
import { Companies, CompanyDashboard } from './views/companies';

// Security Views
import FraudDashboard from './views/fraud/FraudDashboard';
import ActivityLog from './views/activity/ActivityLog';

// Billing Views
import Revenue from './views/revenue/Revenue';
import Plans from './views/plans/Plans';

// Configuration Views
import Developers from './views/developers/Developers';
import GlobalSettings from './views/global/GlobalSettings';
import AILoadBalancer from './views/ai-loadbalancer/AILoadBalancer';
import WhitelabelWizard from './views/whitelabel/WhitelabelWizard';
import FraudConfig from './views/fraud-config/FraudConfig';

// Lazy Marketing Views
import {
  CEODashboard,
  Overview,
  Content,
  Agents,
  Campaigns,
  Leads,
  Video,
  Email,
  Ads,
  SMS,
  Social,
  Analytics,
  CompanyDeep,
  Domains,
  LinkedInScraper,
  Inbox
} from './views/lazy-marketing';

// Auth Activity View
import { AuthActivity } from './views/auth-activity';

import './App.css';

function App() {
  return (
    <>
      {/* SVG Icon Sprite - must be in DOM for references to work */}
      <IconSprite />

      <Routes>
        {/* Public Routes */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/auth/callback" element={<AuthCallback />} />

        {/* Protected Routes */}
        <Route path="/" element={
          <ProtectedRoute>
            <MainLayout />
          </ProtectedRoute>
        }>
          {/* Core */}
          <Route index element={<Dashboard />} />
          <Route path="tenants" element={<Tenants />} />
          <Route path="users" element={<Users />} />

          {/* Companies */}
          <Route path="companies" element={<Companies />} />
          <Route path="companies/:id" element={<CompanyDashboard />} />

          {/* Security */}
          <Route path="fraud" element={<FraudDashboard />} />
          <Route path="activity" element={<ActivityLog />} />

          {/* Billing */}
          <Route path="revenue" element={<Revenue />} />
          <Route path="plans" element={<Plans />} />

          {/* Configuration */}
          <Route path="developers" element={<Developers />} />
          <Route path="settings" element={<GlobalSettings />} />
          <Route path="ai-loadbalancer" element={<AILoadBalancer />} />

          {/* Whitelabel Wizard */}
          <Route path="whitelabel" element={<WhitelabelWizard />} />
          <Route path="fraud-config" element={<FraudConfig />} />

          {/* Auth1 Activity */}
          <Route path="auth-activity" element={<AuthActivity />} />
          <Route path="companies/:id/auth" element={<AuthActivity />} />

          {/* Lazy Marketing routes */}
          <Route path="marketing" element={<CEODashboard />} />
          <Route path="marketing/overview" element={<Overview />} />
          <Route path="marketing/content" element={<Content />} />
          <Route path="marketing/agents" element={<Agents />} />
          <Route path="marketing/campaigns" element={<Campaigns />} />
          <Route path="marketing/leads" element={<Leads />} />
          <Route path="marketing/video" element={<Video />} />
          <Route path="marketing/email" element={<Email />} />
          <Route path="marketing/ads" element={<Ads />} />
          <Route path="marketing/sms" element={<SMS />} />
          <Route path="marketing/social" element={<Social />} />
          <Route path="marketing/analytics" element={<Analytics />} />
          <Route path="marketing/company/:id" element={<CompanyDeep />} />
          <Route path="marketing/domains" element={<Domains />} />
          <Route path="marketing/scraper" element={<LinkedInScraper />} />
          <Route path="marketing/inbox" element={<Inbox />} />
        </Route>
      </Routes>
    </>
  );
}

export default App;
